import { render, staticRenderFns } from "./DividerStyle.vue?vue&type=template&id=4feb2c65&"
import script from "./DividerStyle.vue?vue&type=script&lang=js&"
export * from "./DividerStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports